var exports = {
  "k": "xdbfd91f1--4bb1d7--container",
};

module.exports = exports;
